import HTTPClient from './http-client';
import { createUrl } from "../utils_functions";
const END_POINT = '/readingsdata';

const options = {
  cache: {
      maxAge: 3 * 60 * 1000,
      exclude: { query: false }
  }
}

const loadReadingsData = async ({ datetime_end, datetime_start, organization_ids, quality_ids, sensor_ids, sort, station_ids, stationtype_ids }) => {
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  const url = createUrl(END_POINT, { datetime_end, datetime_start, organization_ids, quality_ids, sensor_ids, sort, station_ids, stationtype_ids });
  return api.get(url, options);
}

export {
    loadReadingsData,
}
